module.exports = __webpack_public_path__ + "static/howjsay-home-ba1457c47b5d97fbb3ec7ce55f9242a1.png";